import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImmomioIconName } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-archive-modal',
  templateUrl: './ticket-archive-modal.component.html',
  styleUrls: ['./ticket-archive-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, IconWebComponent, TranslateModule],
})
export class TicketArchiveModalWebComponent {
  @Input() ticketName = '';
  public activeModal = inject(NgbActiveModal);
  public immomioIconName = ImmomioIconName;
}
